<template>
  <div>
    <router-link :to="'/leadDetail/' + model" class="text-tile-400  "
      ><span>#{{ model }}</span></router-link
    >
  </div>
</template>

<script>
export default {
  name: "lead_id",
  data() {
    return {
      model: null
    };
  },
  props: ["input", "form", "rowdata"],
  created() {
    this.model = this.rowdata;
  },
  watch: {
    form() {
      if (this.form) {
        this.model = null;
      }
    },
    model() {
      this.$parent.$emit("change", {
        name: this.input.name,
        value: this.model
      });
    }
  }
};
</script>

<style></style>
